//import axios from 'axios'
import { defineStore } from 'pinia'
// 修正點：必須在這裡加入 computed
//import { ref, computed } from 'vue'
//import axios from 'axios';


export const useUserCartStore = defineStore('Cart',  {
  
        state: () => ({
            cartData: [],
            cartquantity: 0,
            carttotal: 0
        }),

        getters: {
            getCartList: (state) => state.cartData,
            totalCount: (state) => state.cartData.reduce((sum, item) => sum + (item.quantity || 0), 0),
            totalAmount: (state) => state.cartData.reduce((sum, item) => sum + (item.product_price * item.quantity), 0),
        },
        
        actions: {
            async addcart(product) {
                console.log(product);
                console.log(product.product_id);
                const cartitem = this.cartData.find((item) => item.product_id === product.product_id);
                if (cartitem) {
                cartitem.quantity++;
                } else {
                    this.cartData.push({
                        ...product,
                        quantity: 1
                    });
                }
                    console.log(this.cartData);
                    this.calculateTotals();
                },
                increasecartitem(cartitem){
                    const item = this.cartData.find((item) => item.product_id === cartitem.product_id);
                    item.quantity++;
                    this.calculateTotals();
                },
                decreasecartitem(cartitem){
                    const targetId = Number(cartitem.product_id);
                    const item = this.cartData.find((i) => Number(i.product_id) === targetId);
                    if (!item) {
                        console.warn("找不到該商品，無法減少數量", cartitem);
                            return; 
                    }
                    if (item.quantity <= 1) {
                        this.cartData = this.cartData.filter((i) => Number(i.product_id) !== targetId);
                        console.log(`商品 ${item.product_name} 已從購物車中徹底移除`);
                    } else {
                        item.quantity--;
                    }
                    this.calculateTotals();
                },
                calculateTotals() {
                    this.cartquantity = this.cartData.reduce((sum, item) => sum + (item.quantity || 0), 0);
                    this.carttotal = this.cartData.reduce((sum, item) => sum + (item.product_price * item.quantity), 0);
                },
                removecartitem(product_id) {
                    this.cartData = this.cartData.filter((item) => item.product_id !== product_id);
                    this.calculateTotals();
                }
            },persist: {
        key: 'ShoppingCartData',
        storage: localStorage,
        pick: ['cartData']
    }
});
//https://ithelp.ithome.com.tw/articles/10306919